<template>
  <div v-if="categories && categories.length > 0">
    <h4 v-if="showTitle" class="text-center text-sm-left mb-4 homepage-shiurim-title">
      {{ $t('KW:topicCategories') }}
    </h4>
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 rounded py-3">
      <div v-for="category in categories" class="col p-3">
        <router-link :to="'/topics?category=' + category.url_key">
          <b-card class="topic-category-card h-100" :img-src="imgsrc(category)" :img-alt="category.name" img-height="125px" img-top img-fluid>
            <b-card-text class="text-center py-2">
              <span class="magid-shiur-name">
                {{ category.name }}
              </span>
              <br />
              <span v-if="category.topics_count" class="magid-shiur-count">
                {{ category.shiurim_count }} {{ category.shiurim_count > 1 ? $_t('KW:shiurim') : $_t('KW:shiur') }}
              </span>
            </b-card-text>
          </b-card>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { showTitle: { default: true } },
  mounted() {
    this.$store.dispatch('api/loadTopicCategories').then(categories => (this.categories = categories));
  },
  methods: {
    imgsrc(category) {
      return category.image ? category.image.thumbnail : null;
    },
  },
  data() {
    return { categories: null };
  },
};
</script>

<style scoped></style>
